/**
 * Product Before/After Slider Injection
 * Replaces/augments the main product image with an interactive comparison slider
 * Configuration is set via window.ProductBASliderConfig from Liquid
 */

(function() {
  'use strict';

  // Get configuration from Liquid-injected global
  const CONFIG = window.ProductBASliderConfig || {
    beforeImage: '',
    afterImage: '',
    beforeLabel: 'Original Photo',
    afterLabel: 'Custom Paint By Number'
  };

  // Don't run if no images configured
  if (!CONFIG.beforeImage || !CONFIG.afterImage) {
    console.log('Product BA Slider: No images configured');
    return;
  }

  // Create the slider HTML
  function createSliderHTML() {
    return `
      <div class="product-ba-slider-wrapper" id="productBASlider">
        <div class="product-ba-slider">
          <img
            class="product-ba-image product-ba-image--before"
            src="${CONFIG.beforeImage}"
            alt="${CONFIG.beforeLabel}"
            draggable="false"
          >
          <img
            class="product-ba-image product-ba-image--after"
            src="${CONFIG.afterImage}"
            alt="${CONFIG.afterLabel}"
            draggable="false"
            id="productBAAfter"
          >
          <div class="product-ba-divider" id="productBADivider"></div>
          <div class="product-ba-handle" id="productBAHandle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15 18 9 12 15 6"/>
              <polyline points="9 18 15 12 9 6" transform="translate(6, 0)"/>
            </svg>
          </div>
          <div class="product-ba-labels">
            <span class="product-ba-label">${CONFIG.beforeLabel}</span>
            <span class="product-ba-label">${CONFIG.afterLabel}</span>
          </div>
        </div>
        <p class="product-ba-hint">Drag to compare</p>
      </div>
    `;
  }

  // Create the slider styles
  function createSliderStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .product-ba-slider-wrapper {
        position: relative;
        width: 100%;
        margin-bottom: 0.75rem;
      }

      .product-ba-slider {
        position: relative;
        width: 100%;
        aspect-ratio: 1/1;
        overflow: hidden;
        cursor: ew-resize;
        user-select: none;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        background: #f1f5f9;
      }

      .product-ba-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .product-ba-image--after {
        clip-path: inset(0 50% 0 0);
      }

      .product-ba-divider {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        width: 3px;
        background: #ffffff;
        transform: translateX(-50%);
        z-index: 10;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
      }

      .product-ba-handle {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 44px;
        height: 44px;
        background: #ffffff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 11;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
        transition: transform 0.2s ease;
      }

      .product-ba-handle:hover {
        transform: translate(-50%, -50%) scale(1.1);
      }

      .product-ba-handle svg {
        width: 20px;
        height: 20px;
        color: #1a1a1a;
      }

      .product-ba-labels {
        position: absolute;
        bottom: 0.75rem;
        left: 0.75rem;
        right: 0.75rem;
        display: flex;
        justify-content: space-between;
        pointer-events: none;
        z-index: 5;
      }

      .product-ba-label {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        font-size: 0.65rem;
        font-weight: 600;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #ffffff;
        background: rgba(26, 26, 26, 0.85);
        padding: 0.4rem 0.75rem;
        border-radius: 50px;
        backdrop-filter: blur(4px);
      }

      .product-ba-hint {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        font-size: 0.7rem;
        color: #64748b;
        text-align: center;
        margin: 0.5rem 0 0;
      }

      /* Hide when viewing other gallery images */
      .product-ba-slider-wrapper.hidden {
        display: none;
      }

      /* Ensure it fits in the product gallery */
      .product__media-wrapper .product-ba-slider-wrapper {
        max-width: 100%;
      }
    `;
    document.head.appendChild(style);
  }

  // Initialize slider functionality
  function initSlider() {
    const slider = document.querySelector('.product-ba-slider');
    const handle = document.getElementById('productBAHandle');
    const divider = document.getElementById('productBADivider');
    const afterImg = document.getElementById('productBAAfter');

    if (!slider || !handle || !divider || !afterImg) return;

    let isDragging = false;

    function updateSlider(x) {
      const rect = slider.getBoundingClientRect();
      let percent = ((x - rect.left) / rect.width) * 100;
      percent = Math.max(0, Math.min(100, percent));

      handle.style.left = percent + '%';
      divider.style.left = percent + '%';
      afterImg.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
    }

    function onStart(e) {
      isDragging = true;
      slider.style.cursor = 'grabbing';
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      updateSlider(clientX);
    }

    function onMove(e) {
      if (!isDragging) return;
      e.preventDefault();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      updateSlider(clientX);
    }

    function onEnd() {
      isDragging = false;
      slider.style.cursor = 'ew-resize';
    }

    slider.addEventListener('mousedown', onStart);
    slider.addEventListener('touchstart', onStart, { passive: true });

    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });

    document.addEventListener('mouseup', onEnd);
    document.addEventListener('touchend', onEnd);
  }

  // Inject the slider into the product gallery
  function injectSlider() {
    // Find the product media gallery - try multiple selectors
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    const mediaGallery = document.querySelector('media-gallery') ||
                         document.querySelector('.product__media-gallery') ||
                         document.querySelector('[id^="MediaGallery"]');

    const targetContainer = mediaGallery || mediaWrapper;

    if (!targetContainer) {
      console.log('Product BA Slider: Media gallery not found');
      return;
    }

    // Create slider element
    const sliderContainer = document.createElement('div');
    sliderContainer.innerHTML = createSliderHTML();
    const sliderElement = sliderContainer.firstElementChild;

    // Find the first media item and hide it, inserting slider before it
    const firstMedia = targetContainer.querySelector('.product__media-item') ||
                       targetContainer.querySelector('.product__media') ||
                       targetContainer.querySelector('li');

    if (firstMedia) {
      // Store reference to first media for toggling
      firstMedia.dataset.originalDisplay = firstMedia.style.display || '';
      firstMedia.style.display = 'none';
      firstMedia.parentNode.insertBefore(sliderElement, firstMedia);
    } else {
      // If no media items, just prepend to container
      if (mediaWrapper) {
        mediaWrapper.prepend(sliderElement);
      } else {
        targetContainer.prepend(sliderElement);
      }
    }

    // Initialize slider interaction
    initSlider();

    // Handle thumbnail clicks to toggle between slider and gallery
    setupThumbnailNavigation(sliderElement, firstMedia);

    console.log('Product BA Slider: Injected successfully');
  }

  // Setup thumbnail navigation to show/hide slider
  function setupThumbnailNavigation(sliderElement, firstMedia) {
    // Find thumbnail list
    const thumbnailList = document.querySelector('.thumbnail-list');
    if (!thumbnailList) return;

    // First, add the slider thumbnail
    const sliderThumb = addSliderThumbnail(thumbnailList, sliderElement, firstMedia);

    // Now attach click handlers to ALL original thumbnails (not the slider thumb)
    const allThumbs = thumbnailList.querySelectorAll('li');
    allThumbs.forEach((thumbLi, index) => {
      // Skip the slider thumbnail we just added (index 0)
      if (index === 0) return;

      const button = thumbLi.querySelector('button, [role="button"]');
      if (button) {
        button.addEventListener('click', () => {
          // Hide slider, show the normal gallery
          sliderElement.classList.add('hidden');
          if (firstMedia) {
            firstMedia.style.display = firstMedia.dataset.originalDisplay || '';
          }

          // Update active states - remove from slider thumb
          if (sliderThumb) {
            const sliderBtn = sliderThumb.querySelector('button');
            if (sliderBtn) {
              sliderBtn.classList.remove('is-active');
              sliderBtn.setAttribute('aria-current', 'false');
            }
          }
        });
      }
    });
  }

  // Add a custom thumbnail for the BA slider
  function addSliderThumbnail(thumbnailList, sliderElement, firstMedia) {
    const firstThumb = thumbnailList.querySelector('li');
    if (!firstThumb) return null;

    // Clone and modify the first thumbnail
    const sliderThumb = firstThumb.cloneNode(true);
    sliderThumb.dataset.baSliderThumb = 'true';
    const thumbImg = sliderThumb.querySelector('img');
    const thumbButton = sliderThumb.querySelector('button');

    if (thumbImg) {
      thumbImg.src = CONFIG.beforeImage;
      thumbImg.alt = 'Before/After Comparison';
    }

    if (thumbButton) {
      // Reset aria attributes
      thumbButton.setAttribute('aria-current', 'true');
      thumbButton.classList.add('is-active');

      // Add click handler
      thumbButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Show slider, hide first media
        sliderElement.classList.remove('hidden');
        if (firstMedia) firstMedia.style.display = 'none';

        // Update active states on all thumbnails
        thumbnailList.querySelectorAll('button').forEach(btn => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-current', 'false');
        });
        thumbButton.classList.add('is-active');
        thumbButton.setAttribute('aria-current', 'true');
      });
    }

    // Insert at the beginning of the thumbnail list
    thumbnailList.insertBefore(sliderThumb, firstThumb);

    // Update the original first thumbnail to not be active
    const origButton = firstThumb.querySelector('button');
    if (origButton) {
      origButton.classList.remove('is-active');
      origButton.setAttribute('aria-current', 'false');
    }

    return sliderThumb;
  }

  // Main initialization
  function init() {
    createSliderStyles();

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        // Small delay to ensure product gallery is fully rendered
        setTimeout(injectSlider, 150);
      });
    } else {
      setTimeout(injectSlider, 150);
    }
  }

  init();
})();
